import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultSwapSeatPickerAssets = {
    failedToLoadDataIconName: 'swap-seats-strike',
    swapSeatsUnavailableIconName: 'swap-seats-strike'
};
export const swapSeatPickerAssetsValidatorSchema = {
    failedToLoadDataIconName: nonEmptyStringValidator,
    swapSeatsUnavailableIconName: nonEmptyStringValidator
};
export const swapSeatPickerAssetsValidator = Validator.object(swapSeatPickerAssetsValidatorSchema);
